import { sendPostRequest, API_CONFIG } from '../../helper/HttpHelper'
import { camelCaseToTitle, readableDate } from '../../component/Helper';
import { BuildList } from '../../component/List'

function ManageSupplierUserScreen(){
  const listJSON = {
      'body':{
        'title':'Manage Users',
        'format':{'create_datetime':readableDate},
        'action':{ 'action_text':'Delete User', 'title':'Delete User!', 
                   'content':'By clicking, you agree to delete the user', 'endpoint': API_CONFIG.API_BASE_URL + 'supplier/deleteSupplierUser'},
        'exclude':['eid', 'enterprise_type'] 
      },
      'fetch':{ 'endpoint': API_CONFIG.API_BASE_URL + 'supplier/getAllUsers'}
  }
  return BuildList({listJSON: listJSON})
}
export { ManageSupplierUserScreen}